import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';
import getOrderedParts from './getOrderedParts';

const postOrderedParts = createAsyncThunk('orderedParts/postOrderedParts',
  async (formData = {}, { rejectWithValue, dispatch }) => {
    try {
      const data = await authSet(METHOD_POST, '/co/ordered_parts', formData);
      dispatch(getOrderedParts());
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export const clearPostOrderedParts = createAction('orderedParts/clearPostOrderedParts');

export default postOrderedParts;
